import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "@helpers/axios/private.axios";
import { useTranslation } from "@helpers/translate";
import { ALERT, USER } from "../../../../../../constants";

const TRADE_CONFIRMATIONS_URL = "/users/trade-confirmations";

/**
 * "Don't ask again" of the trade confirmations, saved on the user.
 * A flag is one of CONFIRM_SKIP_FLAG.
 *
 * @returns {{
 *   isConfirmSkipped: (flag: string) => boolean,
 *   skipConfirm: (flag: string) => Promise<void>,
 * }}
 */
export const useTradeConfirmSkips = () => {
  const dispatch = useDispatch();
  const { __ } = useTranslation();
  const user = useSelector((state) => state.user.user);

  const isConfirmSkipped = useCallback(
    (flag) => Boolean(user?.[flag]),
    [user],
  );

  const skipConfirm = async (flag) => {
    dispatch({ type: USER.USER_FIELD, payload: { [flag]: true } });

    try {
      await axios.patch(TRADE_CONFIRMATIONS_URL, { [flag]: true });
    } catch (error) {
      // The modal asks again next time, the trade itself is already confirmed
      dispatch({ type: USER.USER_FIELD, payload: { [flag]: false } });
      dispatch({ type: ALERT.ALERT_ERROR, payload: __("common.error") });
    }
  };

  return { isConfirmSkipped, skipConfirm };
};
